import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EditUserModalPage } from './edit-user-modal';

@NgModule({
  declarations: [
    EditUserModalPage,
  ],
  imports: [
    IonicPageModule.forChild(EditUserModalPage),
  ],
})
export class EditUserModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/edit-user-modal/edit-user-modal.module.ts